import { useQuery } from "@tanstack/react-query"

import { trpcOptions } from "@/utils/trpc"

export const getSessionConfigOptions = (sessionId: string) =>
  trpcOptions.sessions.getSessionConfig.queryOptions({ sessionId })

export function useGetSessionConfig(sessionId: string) {
  return useQuery(getSessionConfigOptions(sessionId))
}
